import { Button, Card, Link, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCurrentCustomerNumber } from "../../../redux/customer";
import { useEffect, useState } from "react";
import { Device } from "./types";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getCorpChildrenDevices } from './services'

type Props = {
  count: number;
}

const ExpiringItems = ({ count }: Props) => {
  const theme = useTheme();
  const customerNumber = useSelector(selectCurrentCustomerNumber);
  const navigate = useNavigate();
  const [expiringItems, setExpiringItems] = useState<Device[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [allLoaded, setAllLoaded] = useState<boolean>(false);

  const loadAdditionalData = async () => {
    setLoading(true);

    try {
      const queryParams = `?scope=expiring&limit=${count}&offset=100`
      const customerDevices = await getCorpChildrenDevices(customerNumber, queryParams)
      setExpiringItems((currentItems) => ([...currentItems, customerDevices]));
      setLoading(false);
      setAllLoaded(true);
    } catch(error) {
      console.error(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (customerNumber && expiringItems.length === 0) {
      setLoading(true);

      (async () => {
        try {
          const queryParams = '?scope=expiring&limit=100'
          const customerDevices = await getCorpChildrenDevices(customerNumber, queryParams)
          setExpiringItems(customerDevices);
          setLoading(false);
          setAllLoaded(true);
        } catch(error) {
          console.error(error);
          setLoading(false);
        }
      })()
    }
  }, [customerNumber])

  return (
    <Card variant="outlined">
      <div className="box-header">{expiringItems.length} Expiring Items</div>
      <DataGrid
        sx={{ borderLeft: "none", borderRight: "none", borderBottom: "none", borderRadius: "0" }}
        rows={expiringItems.map(item => ({ ...item, id: `${item.kit_id}${Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)}` }))}
        columns={[
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 400,
            renderCell: (params) => (
              <Link component="button" onClick={() => navigate(`/corp/practice/${params.row.customer_number}/devices`)} sx={{ color: theme.palette.linkColor.main, textDecoration: 'none' }}>
                {params.row.name.trim()} ({params.row.customer_number})
              </Link>
            )
          },
          {
            field: "city",
            headerName: "Location",
            flex: 1,
            minWidth: 250,
            renderCell: (params) => (
              `${params.row.city}, ${params.row.state}`
            )
          },
          {
            field: "kit_type",
            headerName: "Kit",
            flex: 1,
            minWidth: 100
          },
          {
            field: "item_description",
            headerName: "Item",
            flex: 1,
            minWidth: 400,
            renderCell: (params) => (
              <span>{params.row.quantity} {params.row.item_description}</span>
            )
          },
          {
            field: "expiration_date",
            headerName: "Expiration Date",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => (
              <span className="color-warning">{dayjs(params.row.expiration_date).format("MM/DD/YYYY")}</span>
            )
          }
        ]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
          sorting: {
            sortModel: [
              {
                field: 'expiration_date',
                sort: 'desc'
              }
            ]
          }
        }}
        pageSizeOptions={[5, 10, 20, 25, 50, 100]}
        loading={loading}
        autoHeight
        density="compact"
      />
      {count > 100 && !allLoaded && (
        <div className="flex flex-center m-b-16"><Button onClick={loadAdditionalData}>Load additional data</Button></div>)
      }
    </Card>
  )
}

export default ExpiringItems;